import type {TagType} from 'nutshell-graphql-types';

export const getActiveTable = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const entityName = urlParams.get('entityName');

    switch (entityName) {
        case 'Accounts':
            return 'ACCOUNT';
        case 'Contacts':
            return 'CONTACT';
        case 'Leads':
        default:
            return 'LEAD';
    }
};

export const getReportUrl = (tagType: TagType, id: string) => {
    switch (tagType) {
        case 'ACCOUNT':
            return `/companies?filter[tags]=${id}`;
        case 'CONTACT':
            return `/people?filter[tags]=${id}`;
        case 'LEAD':
        default:
            return `/leads?filter[tags]=${id}&view=list`;
    }
};
